// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"87":"373070db19ffb20d06bc","148":"deea327f42f88c6f504a","201":"9d67966d30e15c39a3fd"}[chunkId] + ".chunk.js";
};